<template>
    <div>
        <Navbar />
        <div class="slot-holder">
            <slot />
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
    components: {
        Navbar
    }
}
</script>

<style>

</style>
